import { Injectable, inject } from '@angular/core';
import { AggregationKey } from '../../../model/aggregations';
import { orderedRegionen } from '../../../model/regionenliste';
import { FacettenService } from '../facetten.service';
import { RegionenUrlService } from './regionenurl.service';

@Injectable({
  providedIn: 'root'
})
export class RegionenService extends FacettenService {
  constructor() {
    const urlService = inject(RegionenUrlService);

    super(urlService, AggregationKey.Regionen, orderedRegionen);
  }
}
